module.exports = __webpack_public_path__ + "static/media/manualIcon.30792679.svg";